import React from "react";
import { Link } from "react-router-dom";

export const buklEmailColumns = (handleEdit, handleDelete, PAGE_SIZE) => [
  {
    label: "S.No",
    width: 50,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    label: "Date",
    width: 120,
    render: (row) => (
      <>
        <span>
          {row?.createdAt
                ? new Date(row.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                : "-"}
    </span>
        
      </>
    ),
  },
  {
    label: "Send To",
    render: (row) => row.sendTo
  },
  {
    label: "Action",
    width: 120,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link to="#" onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link to="#" onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
];
